var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import Input from '../../components/Input';
import Button from '../../components/Button';
import require from '../../lib/WithValidation/rules/required';
import marked from 'marked';
import PropTypes from 'prop-types';
import translate from '../../lib/utils/translate';

var RequestResetPassword = function (_Component) {
  _inherits(RequestResetPassword, _Component);

  function RequestResetPassword() {
    _classCallCheck(this, RequestResetPassword);

    return _possibleConstructorReturn(this, (RequestResetPassword.__proto__ || Object.getPrototypeOf(RequestResetPassword)).apply(this, arguments));
  }

  _createClass(RequestResetPassword, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          status = _props.status,
          successMsg = _props.successMsg,
          errors = _props.errors,
          intl = _props.intl,
          onSubmit = _props.onSubmit,
          _onBlur = _props.onBlur,
          isLoading = _props.isLoading;


      if (status == 'COMPLETE') {
        return React.createElement('div', { dangerouslySetInnerHTML: { __html: marked(successMsg.content) } });
      }

      return React.createElement(
        'form',
        { className: 'form', onSubmit: onSubmit },
        React.createElement(Input, {
          label: translate({ id: 'label.username_or_email' }, intl),
          type: 'text',
          name: 'UsernameOrEmail',
          onBlur: function onBlur(e) {
            return _onBlur('UsernameOrEmail', e.target.value);
          },
          status: errors.UsernameOrEmail && 'failure' || 'idle',
          statusText: errors.UsernameOrEmail && translate({ id: errors.UsernameOrEmail }, intl)
        }),
        React.createElement(
          Button,
          {
            className: 'button primary wide',
            type: 'submit',
            isLoading: isLoading },
          translate({ id: 'label.request_reset_password' }, intl)
        )
      );
    }
  }]);

  return RequestResetPassword;
}(Component);

RequestResetPassword.propTypes = {
  /** Input field expecting valid username or email */
  children: PropTypes.any,
  /** Label for input field */
  label: PropTypes.string,
  /** Errors for invalid values in the input field */
  errors: PropTypes.array,
  /** Submitting the form */
  onSubmit: PropTypes.func.isRequired,
  /** Leaving focus from the input field */
  onBlur: PropTypes.func.isRequired
};
RequestResetPassword.defaultProps = {
  children: '',
  label: 'label.username_or_email',
  errors: []
};


var rules = {
  UsernameOrEmail: [[require, 'error.empty.username_or_email']]
};

export default compose(WithValidation(rules), injectIntl)(RequestResetPassword);